import { createGlobalStyle } from 'styled-components';
import { createTheme } from "@mui/material/styles";

export const GlobalStyle = createGlobalStyle`body {
    font-family: Lato, sans-serif;
}`

// MUI's default 11px tooltip was reported as too small to read in a test meeting.
//
// A nested createTheme() does not inherit this from the root theme — its `components`
// replaces the root's rather than merging — so any view with its own theme has to spread
// this in explicitly. Views that already override MuiTooltip should merge their own
// `tooltip` rules into this one rather than nesting the whole block.
export const tooltipStyleOverrides = {
    fontSize: '14px',
    padding: '8px 12px',
};

export const theme = createTheme({
    typography: {
        fontFamily: 'Lato, sans-serif'
    },
    components: {
        MuiTooltip: {
            styleOverrides: {
                tooltip: {...tooltipStyleOverrides},
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    '&:hover': {
                        color: '#FFC540',
                    },
                    '&.Mui-selected': {
                        backgroundColor: '#FFC540',
                        color: '#3A3E3F',
                        '&:hover': {
                            backgroundColor: '#FFC540',
                            color: '#3A3E3F',
                        },
                    },
                },
            },
        },
    },
})